var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgNewspaper = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6 7.571h.571V4A.429.429 0 0 1 7 3.571h14a.428.428 0 0 1 .429.429v13A3.429 3.429 0 0 1 18 20.429H5A2.429 2.429 0 0 1 2.571 18V8A.429.429 0 0 1 3 7.571h3ZM4 8.43h-.571V18a1.571 1.571 0 1 0 3.142 0V8.429H4Zm3.283 10.376-.278.766H18A2.572 2.572 0 0 0 20.571 17V4.429H7.43V17.998a2.428 2.428 0 0 1-.146.807ZM16 11.571h1a.428.428 0 1 1 0 .858h-1a.428.428 0 1 1 0-.858Zm0 4h1a.428.428 0 1 1 0 .858h-1a.428.428 0 1 1 0-.858Zm1-7.142h-6a.428.428 0 1 1 0-.858h6a.428.428 0 1 1 0 .858Zm-5 4h-1a.428.428 0 1 1 0-.858h1a.428.428 0 1 1 0 .858Zm0 4h-1a.428.428 0 1 1 0-.858h1a.428.428 0 1 1 0 .858Z",
  stroke: "currentColor",
  strokeWidth: 1.143
})));

export default SvgNewspaper;